import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext';
import ClientContext from '../../../contexts/ClientContext';


//import { useEffect} from "react";
import { PushButton } from '../pushbutton/PushButton';

export const DialogBoughtCredits = () => {
  
    let {
      changeLanguage,
      showDialogBoughtCredits,
      setShowDialogBoughtCredits,
    } = React.useContext(StatusContext);

    const {
      availablecredits
    } = React.useContext(ClientContext);
  
    /*
  useEffect(() => {
   

    let boughtcredits = sessionStorage.getItem('CreditsPurchaseSuccess')
    if (boughtcredits)
    {
      setShowDialogBoughtCredits(true)
      sessionStorage.removeItem('CreditsPurchaseSuccess')
    }
    }, [setShowDialogBoughtCredits])
*/

   
  const handleOnClick = () => {

    setShowDialogBoughtCredits(false)
    sessionStorage.removeItem('PurchaseType')  
  
  }

 

  return (
    <React.Fragment>
   
        <Dialog
          open={showDialogBoughtCredits}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <DialogTitle className="dialogProgressTitle" style = {{fontSize:'20px', color:'maroon'}}>{changeLanguage('home', 'boughtcredits')}</DialogTitle>

        <DialogContent dividers>
         
        <div className="signupPlans">
        
          
       
          <br></br>
          <div className="getcreditsText" style={{fontSize: '20px', fontWeight:'500'}}>
           
            {changeLanguage('creditssuccess', 'thankyou')}
              <br></br>
              <br></br>
           

              <div className="creditssuccessText">
                <span> {changeLanguage('creditssuccess', 'totalcredits')} {availablecredits.toLocaleString()}.</span>
              </div>
              <br></br>
           
              <PushButton label={changeLanguage('dialog', 'ok')} onClick={handleOnClick}/>
              <br></br>
          

          
              
          </div>
       
         </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
   
  )
}

export default DialogBoughtCredits
